module.exports = __webpack_public_path__ + "static/media/weth.802c6eac.svg";